import React, { useState } from 'react';

const AddSubjectForm = ({ addSubjects }) => {
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    addSubjects(name);
  };

  return (
    <div>
      <form className='class-form' onSubmit={handleSubmit}>
        <div className='form-control'>
          <label htmlFor='name'>Subject Name</label>
          <input
            type='text'
            required
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </div>
        <button type='submit' className='btn'>
          Add Subject
        </button>
      </form>
    </div>
  );
};

export default AddSubjectForm;
